module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/1-5ebab7b99b2b219ae234150c9368d97b.webp";